var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.878 1.332A.727.727 0 009.849.304L6 4.154 2.15.303a.727.727 0 00-1.028 1.028l4.364 4.364a.727.727 0 001.028 0l4.364-4.364z","fill":"#FFF","fillRule":"evenodd"}));
}

Arrow.defaultProps = {"viewBox":"0 0 12 6"};

module.exports = Arrow;

Arrow.default = Arrow;
